import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/contracts/create')({
  loader: ({ params }) => {
    throw redirect({
      to: '/$orgId/pricing/create',
      params: { orgId: params.orgId },
      replace: true,
    })
  },
})
